class DetailsDisclosure extends HTMLElement {
	constructor() {
		super()
		this.mainDetailsToggle = this.querySelector('details')

		this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this))
		this.addEventListener('mouseenter', this.onMouseEnter.bind(this))
		this.addEventListener('mouseleave', this.onMouseLeave.bind(this))
	}

	onFocusOut() {
		setTimeout(() => {
			if (!this.contains(document.activeElement)) this.close()
		})
	}

	onMouseEnter() {
		this.mainDetailsToggle.open = true
		this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true)
	}

	onMouseLeave() {
		this.mainDetailsToggle.open = false
		this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false)
	}

	close() {
		this.mainDetailsToggle.removeAttribute('open')
		this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false)
	}
}

customElements.define('details-disclosure', DetailsDisclosure)

